import * as openLocationCode from "open-location-code";

const codec =
  (openLocationCode as { OpenLocationCode?: unknown }).OpenLocationCode ??
  (openLocationCode as { default?: unknown }).default ??
  openLocationCode;

export const toPlusCode = (lat: number, lon: number) => {
  const encode = (codec as { encode?: (lat: number, lon: number) => string })
    .encode;
  if (typeof encode === "function") {
    return encode(lat, lon);
  }
  return null;
};
